require('./feature-freespin.css');

$.ready(function () {
    game.generateFreespin = function (key, config) {
        if (typeof key === 'object') {
            config = key;
            key = null;
        }

        key = key || 'freespin';

        var freespin = $.div('bonus-' + key);
        freespin.key = key;

        config = freespin.config = config || {};

        game.on('spin_init', function () {
            if (game.last.scatters) {
                for (var i = 0; i < game.last.scatters.pays.length; i++) {
                    if (game.last.scatters.pays[i][2] === key) {
                        game.last.scatters.pays[i][2] = config.name || 'Free Spins';
                    }
                }
            }
        });

        /* Play Button */
        {
            freespin.play = $.div().addClass('message');
            freespin.play.message = $.div().html('Touch to Begin').appendTo(freespin.play);

            freespin.playing = $.div();

            freespin.spins = $.div()
                .apply('meter', {label: 'Spins'})
                .addClass('spins')
                .appendTo(freespin.playing)
            ;

            freespin.total = $.div()
                .apply('meter', {label: 'Total'})
                .addClass('total')
                .appendTo(freespin.playing)
            ;

            game.panel.registerCash(freespin.total);
        }

        if (config.banners) {
            for (var i = 0; i < config.banners; i++) {
                var banner = $.div().addClass('banner ' + key + '-banner-' + i);
                game.messaging.add(key + '-banner-' + i, banner);

                freespin.banners = {
                    index: -1,
                    count: config.banners,
                };
            }

            var minTriggers = config.minTriggers || 3;
            freespin.singleTriggerBanner = null;

            if (config.triggerBanners) {
                freespin.singleTriggerBanner = config.triggerBanners === 1 ? true : false;

                if (!freespin.singleTriggerBanner) {
                    for (var j = 0; j < config.triggerBanners; j++) {
                        var bannerNum = j + minTriggers;
                        var triggerBanner = $.div().addClass('banner ' + key + '-triggerBanner-' + bannerNum);
                        game.messaging.add(key + '-triggerBanner-' + bannerNum, triggerBanner);
                    }
                }

                else {
                    var triggerBanner = $.div().addClass('banner ' + key + '-triggerBanner');
                    game.messaging.add(key + '-triggerBanner', triggerBanner);
                }

                freespin.triggerBanners = {
                    index: -1,
                    count: config.triggerBanners,
                };
            }
        }

        freespin.on('play', function () {
            if (!freespin.ready || freespin.inited || freespin.config.waitStart) {
                return;
            }

            freespin.inited = true;
            game.sounds.play([freespin.key, 'click']);

            freespin.addClass('spinning');
            freespin.removeClass('pause');

            if (game.panel.type === 'desktop') {
                this.play.remove();
                this.playing.appendTo(game.panel.play);
            }

            if (game.panel.type === 'mobile') {
                setTimeout(function () {
                    game.panel.play.removeClass('icon-begin');
                    game.panel.play.addClass('icon-spin');
                    freespin.total.addClass('bottom right').appendTo(game.panel);
                }, 750);
            }

            else {
                freespin.total.appendTo(freespin.playing);
            }

            freespin.methods.next(game.last.spins);
        });

        freespin.methods = {};

        for (var method in game.generateFreespin.methods) {
            freespin.methods[method] = game.generateFreespin.methods[method].bind(freespin);
        }

        game.on('round_complete', function () {
            if (game.feature.active !== freespin.key || game.last.delayWin || game.last.stopSpins || game.last.doubleRollup) {
                return;
            }

            if (freespin.config.down) {
                freespin.spins.max = game.last.state.spins_aquired;
            }

            freespin.spins.set(freespin.config.down ? (game.last.state.spins_aquired - game.last.state.spins) : game.last.state.spins);

            freespin.total.set((game.last.state.win + freespin.initial_credits) * game.panel.denom.get());

            var didRetrigger = false;

            if (game.last.scatters) {
                var count = game.last.scatters.counts[freespin.config.symbol];

                if (game.config.scatters.constructor === Array) {
                    for (var i in game.config.scatters) {
                        if (game.config.scatters[i].paytable[freespin.config.symbol]) {
                            didRetrigger = didRetrigger || game.config.scatters[i].paytable[freespin.config.symbol][count - 1];
                        }
                    }
                }

                else {
                    if (game.config.scatters.paytable[freespin.config.symbol]) {
                        didRetrigger = game.config.scatters.paytable[freespin.config.symbol][count - 1];
                    }
                }
            }

            if (game.last.retriggered) {
                didRetrigger = true;
            }

            setTimeout(function () {
                freespin.methods.next(game.last.spins);
            }, freespin.config.triggerTime && didRetrigger ? freespin.config.triggerTime : 1000);
        });

        return freespin;
    };

    game.generateFreespin.methods = {
        init: function (recall) {
            this.inited = false;
            this.ready = false;
            this.attr('class', 'intro');

            if (recall) {
                this.initial_credits = 0;
                if (game.last.scatters) {
                    var sym = this.config.symbol || this.config.initial_credits.symbol;

                    for (var i = 0; i < game.last.scatters.pays.length; i++) {
                        if (game.last.scatters.pays[i][0] === sym && typeof game.last.scatters.pays[i][2] === 'number') {
                            this.initial_credits = game.last.scatters.pays[i][2];
                            break;
                        }
                    }
                }

            }

            setTimeout(function () {
                game.panel.auto.label.html('Auto');
            }, 500);

            if (this.config.introSymbol) {
                game.feature.showMessage('intro_' + game.last.scatters.counts[this.config.introSymbol]);
            }

            else if (this.config.symbol === 0 || this.config.symbol) {
                game.feature.showMessage('intro_' + game.last.scatters.counts[this.config.symbol]);
            }

            else if (!this.config.noIntroMessage) {
                game.feature.showMessage('intro');
            }

            if (!this.config.noAutomatedSounds) {
                var intro = game.sounds.play([this.key, 'intro']);

                game.sounds.play([this.key, 'background'], {loop: true, time: intro ? intro.buffer.duration : 0});
            }

            if (game.panel.type === 'mobile') {
                game.panel.spin.css('display', 'none');
                game.panel.addItem(this.spins, 'bottom middle');
                this.total.addClass('bottom right').appendTo(game.panel);
                this.total.label.appendTo(this.total);
                this.total.animate = true;
                this.total.exclusiveSet = false;

                game.panel.on('setWin', function (event) {
                    if (game.feature.active !== this.key) {
                        return;
                    }

                    if (event.detail.value === 0 || this.total.exclusiveSet) {
                        return;
                    }

                    this.total.exclusiveSet = true;


                    this.total.set((game.last.state.win + this.initial_credits) * game.panel.denom.get(), event.detail.immediate);
                }.bind(this));
            }

            this.trigger('init', {recall: recall});
        },

        begin: function (response, recall) {
            this.trigger('begin', {recall: recall});
            this.scattersCount = null;
            this.multiplier = response.multiplier;

            if (!recall) {
                this.initial_credits = 0;
            }

            if (this.config.initial_credits && !recall) {
                var sym = this.config.symbol || this.config.initial_credits.symbol;

                for (var i = 0; i < game.old.scatters.pays.length; i++) {
                    if (game.old.scatters.pays[i][0] === sym && typeof game.old.scatters.pays[i][2] === 'number') {
                        this.initial_credits = game.old.scatters.pays[i][2];
                        break;
                    }
                }
            }

            if (this.config.line_trigger && !recall) {
                this.initial_credits = game.old.triggering_pay || 0;
            }

            this.total.set((response.total + this.initial_credits) * game.panel.denom.get());

            if (this.config.down) {
                this.spins.max = game.last.spins_aquired;
            }

            this.spins.set(this.config.down ? (game.last.spins_aquired - game.last.spins) : game.last.spins);

            var freespin = this;
            setTimeout(function () {
                if (!freespin.config.noIntroMessage) {
                    game.feature.hideMessages();
                }

                freespin.addClass('pause');
                freespin.removeClass('intro');

                if (!recall) {
                    if (game.panel.type === 'desktop') {
                        freespin.play.appendTo(game.panel.play);
                    }

                    if (game.panel.type === 'mobile') {
                        game.panel.play.addClass('icon-begin');
                    }
                }

                freespin.trigger('intro', {recall: recall});

                freespin.ready = true;

                if (recall) {
                    freespin.addClass('spinning');
                    freespin.removeClass('pause');

                    freespin.trigger('play');
                }
            }, recall ? 2000 : (this.config.introTime || 7500));
        },

        next: function (spins) {
            this.trigger('next');

            if (spins && !game.inRecall) {
                spinClear();
                game.spindle.spin();
            }

            game.controller.socket.emit('feature', {name: this.key, action: spins ? 'spin' : 'finish'});
        },

        spin: function (response, recall) {
            this.trigger('spin', {recall: recall});

            this.spins.set(this.spins._value - 1);

            this.total.exclusiveSet = false;

            game.panel.win.appendTo(game.panel);

            if (this.triggerBanners) {
                if (!this.singleTriggerBanner) {
                    game.messaging.hide(this.key + '-triggerBanner-' + this.triggerBanners.index);
                }

                else {
                    game.messaging.hide(this.key + '-triggerBanner');
                }
            }

            else if (this.banners) {
                game.messaging.hide(this.key + '-banner-' + this.banners.index);
            }

            if ((this.scattersCount > 2 || this.scattersCount >= this.config.minTriggerBanners) && this.triggerBanners) {
                if (!this.singleTriggerBanner) {
                    this.triggerBanners.index = this.scattersCount;
                    game.messaging.hide('logo');
                    game.messaging.show(this.key + '-triggerBanner-' + this.triggerBanners.index);
                }

                else {
                    game.messaging.hide('logo');
                    game.messaging.show(this.key + '-triggerBanner');
                }
            }

            else if (this.banners) {
                this.banners.index = (this.banners.index + 1) % this.banners.count;
                game.messaging.hide('logo');
                game.messaging.show(this.key + '-banner-' + this.banners.index);
            }

            else if (!this.banners) {
                game.messaging.show('logo');
            }

            if (game.last.scatters) {
                this.scattersCount = game.last.scatters.counts[this.config.symbol];
            }
        },

        finish: function (response, recall) {
            this.trigger('finish', {recall: recall});

            game.messaging.hide();
            game.messaging.show('logo');

            this.playing.remove();

            if (game.panel.type === 'mobile') {
                game.features.freespin.total.remove();
            }

            game.feature.showMessage('outro', response.win + (this.initial_credits * game.panel.denom.get()));
            this.addClass('final');
            this.removeClass('spinning');

            game.sounds.fade([this.key, 'background'], 1, 0, 0.5);
            game.sounds.play([this.key, 'outro']);

            if (game.panel.type === 'mobile') {
                game.panel.spin.css('display', null);
                this.spins.remove();
            }

            if (recall) {
                return;
            }

            setTimeout(game.feature.finish, (this.config.outroTime || 2500));
        },
    };
});



/** WEBPACK FOOTER **
 ** ./../../public-src/common/feature-freespin/feature-freespin.js
 **/